import CalendarMeetingType from '@/views/apps/calendar/constants/CalendarMeetingType';

export default Object.keys(CalendarMeetingType)
  .filter((key) => key !== 'Canceled')
  .map((calendarType) => ({
    className: `calendar-event-bg calendar-event-bg--${calendarType}`,
    label: `calendar.calendar-type.${calendarType}`,
    calendar: CalendarMeetingType[calendarType],
  }));
